// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/request_generation.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CreditSource } from "../../billing/v1/vision_billing_pb";
import { file_vision_billing_v1_vision_billing } from "../../billing/v1/vision_billing_pb";
import type { GenerationStatus } from "./vision_generation_pb";
import { file_vision_generations_v1_vision_generation } from "./vision_generation_pb";
import type { MaskRegion } from "./mask_region_pb";
import { file_vision_generations_v1_mask_region } from "./mask_region_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/request_generation.proto.
 */
export const file_vision_generations_v1_request_generation: GenFile = /*@__PURE__*/
  fileDesc("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", [file_vision_billing_v1_vision_billing, file_vision_generations_v1_vision_generation, file_vision_generations_v1_mask_region]);

/**
 * @generated from message protos.vision.generations.v1.RequestGenerationRequest
 */
export type RequestGenerationRequest = Message<"protos.vision.generations.v1.RequestGenerationRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.RequestGenerationRequest.Params params = 1;
   */
  params?: RequestGenerationRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.RequestGenerationRequest.
 * Use `create(RequestGenerationRequestSchema)` to create a new message.
 */
export const RequestGenerationRequestSchema: GenMessage<RequestGenerationRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_request_generation, 0);

/**
 * @generated from message protos.vision.generations.v1.RequestGenerationRequest.Params
 */
export type RequestGenerationRequest_Params = Message<"protos.vision.generations.v1.RequestGenerationRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: protos.vision.billing.v1.CreditSource credit_source = 2;
   */
  creditSource: CreditSource;

  /**
   * @generated from oneof protos.vision.generations.v1.RequestGenerationRequest.Params.workflow
   */
  workflow: {
    /**
     * @generated from field: protos.vision.generations.v1.RequestGenerationRequest.Params.StandardImage standard_image = 3;
     */
    value: RequestGenerationRequest_Params_StandardImage;
    case: "standardImage";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.RequestGenerationRequest.Params.Refine refine = 4;
     */
    value: RequestGenerationRequest_Params_Refine;
    case: "refine";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.RequestGenerationRequest.Params.Upscale upscale = 5;
     */
    value: RequestGenerationRequest_Params_Upscale;
    case: "upscale";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.RequestGenerationRequest.Params.Recreate recreate = 6;
     */
    value: RequestGenerationRequest_Params_Recreate;
    case: "recreate";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.RequestGenerationRequest.Params.ImportSceneLook import_scene_look = 7;
     */
    value: RequestGenerationRequest_Params_ImportSceneLook;
    case: "importSceneLook";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.RequestGenerationRequest.Params.SetDressing set_dressing = 8;
     */
    value: RequestGenerationRequest_Params_SetDressing;
    case: "setDressing";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.RequestGenerationRequest.Params.MaskInpaint mask_inpaint = 9;
     */
    value: RequestGenerationRequest_Params_MaskInpaint;
    case: "maskInpaint";
  } | {
    /**
     * @generated from field: protos.vision.generations.v1.RequestGenerationRequest.Params.VisionBoardTextToImage vision_board_text_to_image = 10;
     */
    value: RequestGenerationRequest_Params_VisionBoardTextToImage;
    case: "visionBoardTextToImage";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.vision.generations.v1.RequestGenerationRequest.Params.
 * Use `create(RequestGenerationRequest_ParamsSchema)` to create a new message.
 */
export const RequestGenerationRequest_ParamsSchema: GenMessage<RequestGenerationRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_request_generation, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.RequestGenerationRequest.Params.StandardImage
 */
export type RequestGenerationRequest_Params_StandardImage = Message<"protos.vision.generations.v1.RequestGenerationRequest.Params.StandardImage"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;

  /**
   * @generated from field: string prompt = 2;
   */
  prompt: string;

  /**
   * @generated from field: string aspect_ratio = 3;
   */
  aspectRatio: string;

  /**
   * @generated from field: bool keep_framing = 4;
   */
  keepFraming: boolean;

  /**
   * @generated from field: bool use_thinking = 5;
   */
  useThinking: boolean;

  /**
   * @generated from field: string color_reference_preset_id = 6;
   */
  colorReferencePresetId: string;

  /**
   * @generated from field: repeated string additional_reference_asset_ids = 7;
   */
  additionalReferenceAssetIds: string[];
};

/**
 * Describes the message protos.vision.generations.v1.RequestGenerationRequest.Params.StandardImage.
 * Use `create(RequestGenerationRequest_Params_StandardImageSchema)` to create a new message.
 */
export const RequestGenerationRequest_Params_StandardImageSchema: GenMessage<RequestGenerationRequest_Params_StandardImage> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_request_generation, 0, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.RequestGenerationRequest.Params.Refine
 */
export type RequestGenerationRequest_Params_Refine = Message<"protos.vision.generations.v1.RequestGenerationRequest.Params.Refine"> & {
  /**
   * @generated from field: string parent_generation_id = 1;
   */
  parentGenerationId: string;

  /**
   * @generated from field: string prompt = 2;
   */
  prompt: string;

  /**
   * @generated from field: string aspect_ratio = 3;
   */
  aspectRatio: string;

  /**
   * @generated from field: bool keep_framing = 4;
   */
  keepFraming: boolean;

  /**
   * @generated from field: bool use_thinking = 5;
   */
  useThinking: boolean;

  /**
   * @generated from field: string color_reference_preset_id = 6;
   */
  colorReferencePresetId: string;

  /**
   * @generated from field: repeated string additional_reference_asset_ids = 7;
   */
  additionalReferenceAssetIds: string[];
};

/**
 * Describes the message protos.vision.generations.v1.RequestGenerationRequest.Params.Refine.
 * Use `create(RequestGenerationRequest_Params_RefineSchema)` to create a new message.
 */
export const RequestGenerationRequest_Params_RefineSchema: GenMessage<RequestGenerationRequest_Params_Refine> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_request_generation, 0, 0, 1);

/**
 * @generated from message protos.vision.generations.v1.RequestGenerationRequest.Params.Upscale
 */
export type RequestGenerationRequest_Params_Upscale = Message<"protos.vision.generations.v1.RequestGenerationRequest.Params.Upscale"> & {
  /**
   * @generated from field: string parent_generation_id = 1;
   */
  parentGenerationId: string;

  /**
   * @generated from field: string image_id = 3;
   */
  imageId: string;
};

/**
 * Describes the message protos.vision.generations.v1.RequestGenerationRequest.Params.Upscale.
 * Use `create(RequestGenerationRequest_Params_UpscaleSchema)` to create a new message.
 */
export const RequestGenerationRequest_Params_UpscaleSchema: GenMessage<RequestGenerationRequest_Params_Upscale> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_request_generation, 0, 0, 2);

/**
 * @generated from message protos.vision.generations.v1.RequestGenerationRequest.Params.Recreate
 */
export type RequestGenerationRequest_Params_Recreate = Message<"protos.vision.generations.v1.RequestGenerationRequest.Params.Recreate"> & {
  /**
   * @generated from field: string parent_generation_id = 1;
   */
  parentGenerationId: string;
};

/**
 * Describes the message protos.vision.generations.v1.RequestGenerationRequest.Params.Recreate.
 * Use `create(RequestGenerationRequest_Params_RecreateSchema)` to create a new message.
 */
export const RequestGenerationRequest_Params_RecreateSchema: GenMessage<RequestGenerationRequest_Params_Recreate> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_request_generation, 0, 0, 3);

/**
 * @generated from message protos.vision.generations.v1.RequestGenerationRequest.Params.ImportSceneLook
 */
export type RequestGenerationRequest_Params_ImportSceneLook = Message<"protos.vision.generations.v1.RequestGenerationRequest.Params.ImportSceneLook"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;

  /**
   * @generated from field: string source_image_id = 2;
   */
  sourceImageId: string;

  /**
   * @generated from field: bool clear_scene = 3;
   */
  clearScene: boolean;
};

/**
 * Describes the message protos.vision.generations.v1.RequestGenerationRequest.Params.ImportSceneLook.
 * Use `create(RequestGenerationRequest_Params_ImportSceneLookSchema)` to create a new message.
 */
export const RequestGenerationRequest_Params_ImportSceneLookSchema: GenMessage<RequestGenerationRequest_Params_ImportSceneLook> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_request_generation, 0, 0, 4);

/**
 * @generated from message protos.vision.generations.v1.RequestGenerationRequest.Params.SetDressing
 */
export type RequestGenerationRequest_Params_SetDressing = Message<"protos.vision.generations.v1.RequestGenerationRequest.Params.SetDressing"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;

  /**
   * @generated from field: string set_dressing_reference_asset_id = 2;
   */
  setDressingReferenceAssetId: string;

  /**
   * @generated from field: string aspect_ratio = 3;
   */
  aspectRatio: string;

  /**
   * @generated from field: bool clear_scene = 4;
   */
  clearScene: boolean;

  /**
   * @generated from field: string source_generation_id = 5;
   */
  sourceGenerationId: string;
};

/**
 * Describes the message protos.vision.generations.v1.RequestGenerationRequest.Params.SetDressing.
 * Use `create(RequestGenerationRequest_Params_SetDressingSchema)` to create a new message.
 */
export const RequestGenerationRequest_Params_SetDressingSchema: GenMessage<RequestGenerationRequest_Params_SetDressing> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_request_generation, 0, 0, 5);

/**
 * @generated from message protos.vision.generations.v1.RequestGenerationRequest.Params.MaskInpaint
 */
export type RequestGenerationRequest_Params_MaskInpaint = Message<"protos.vision.generations.v1.RequestGenerationRequest.Params.MaskInpaint"> & {
  /**
   * @generated from field: string image_id = 1;
   */
  imageId: string;

  /**
   * @generated from field: string parent_generation_id = 2;
   */
  parentGenerationId: string;

  /**
   * @generated from field: string aspect_ratio = 3;
   */
  aspectRatio: string;

  /**
   * @generated from field: repeated protos.vision.generations.v1.MaskRegion regions = 4;
   */
  regions: MaskRegion[];
};

/**
 * Describes the message protos.vision.generations.v1.RequestGenerationRequest.Params.MaskInpaint.
 * Use `create(RequestGenerationRequest_Params_MaskInpaintSchema)` to create a new message.
 */
export const RequestGenerationRequest_Params_MaskInpaintSchema: GenMessage<RequestGenerationRequest_Params_MaskInpaint> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_request_generation, 0, 0, 6);

/**
 * @generated from message protos.vision.generations.v1.RequestGenerationRequest.Params.VisionBoardTextToImage
 */
export type RequestGenerationRequest_Params_VisionBoardTextToImage = Message<"protos.vision.generations.v1.RequestGenerationRequest.Params.VisionBoardTextToImage"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;

  /**
   * @generated from field: string aspect_ratio = 2;
   */
  aspectRatio: string;

  /**
   * @generated from field: bool use_thinking = 3;
   */
  useThinking: boolean;

  /**
   * @generated from field: repeated string additional_reference_asset_ids = 4;
   */
  additionalReferenceAssetIds: string[];
};

/**
 * Describes the message protos.vision.generations.v1.RequestGenerationRequest.Params.VisionBoardTextToImage.
 * Use `create(RequestGenerationRequest_Params_VisionBoardTextToImageSchema)` to create a new message.
 */
export const RequestGenerationRequest_Params_VisionBoardTextToImageSchema: GenMessage<RequestGenerationRequest_Params_VisionBoardTextToImage> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_request_generation, 0, 0, 7);

/**
 * @generated from message protos.vision.generations.v1.RequestGenerationResponse
 */
export type RequestGenerationResponse = Message<"protos.vision.generations.v1.RequestGenerationResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.RequestGenerationResponse.Result result = 1;
   */
  result?: RequestGenerationResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.RequestGenerationResponse.
 * Use `create(RequestGenerationResponseSchema)` to create a new message.
 */
export const RequestGenerationResponseSchema: GenMessage<RequestGenerationResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_request_generation, 1);

/**
 * @generated from message protos.vision.generations.v1.RequestGenerationResponse.Result
 */
export type RequestGenerationResponse_Result = Message<"protos.vision.generations.v1.RequestGenerationResponse.Result"> & {
  /**
   * @generated from field: string generation_id = 1;
   */
  generationId: string;

  /**
   * @generated from field: protos.vision.generations.v1.GenerationStatus status = 2;
   */
  status: GenerationStatus;
};

/**
 * Describes the message protos.vision.generations.v1.RequestGenerationResponse.Result.
 * Use `create(RequestGenerationResponse_ResultSchema)` to create a new message.
 */
export const RequestGenerationResponse_ResultSchema: GenMessage<RequestGenerationResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_request_generation, 1, 0);

